<template>
    <confirmation-modal
        v-bind="modals.confirmation"
    />
</template>

<script>
import ConfirmationModal from "../../utils/modals/ConfirmationModal";
import {mapGetters} from "vuex";

export default {
    name: "TestConfirmationModal",
    components: {ConfirmationModal},
    computed: {
        ...mapGetters('tests', [
            'modals',
        ])
    }
}
</script>

<style scoped>

</style>